// @ts-nocheck
import _ from "lodash";
import { checkError as sharedCheckError } from '@staty/shared/utils/validation';

// Re-export shared validation functions
export { checkDuplicate, checkError, onPeriodChange, hasError, isEmpty } from '@staty/shared/utils/validation';

interface FormField {
  value: string;
  errorMsg?: string;
}

interface FormData {
  [key: string]: FormField;
}

// Local function - admin_new hooks-based implementation
export function onUniqueTextPropertyChange(
  e: React.ChangeEvent<HTMLInputElement>,
  propertyName: string = "",
  list: unknown[] = [],
  formData: FormData,
  setFormData: (data: FormData) => void
): void {
  const value = e.target.value;
  console.log("onTextPropertyChange: ", value, propertyName);
  const cloned = _.cloneDeep(formData);
  cloned[propertyName].value = value;
  cloned[propertyName].errorMsg = sharedCheckError(e, list, propertyName);
  setFormData(cloned);
}

interface ClassContext {
  state: {
    formData: FormData;
  };
  setState: (state: { formData: FormData }) => void;
}

// Local function - admin_new class-based implementation
export function onTextPropertyChange(
  e: React.ChangeEvent<HTMLInputElement>,
  propertyName: string = "",
  list: unknown[] = [],
  context: ClassContext
): void {
  const value = e.target.value;
  console.log("onTextPropertyChange: ", value, propertyName);
  const cloned = _.cloneDeep(context.state.formData);
  cloned[propertyName].value = value;
  cloned[propertyName].errorMsg = sharedCheckError(e, list, propertyName);
  context.setState({
    formData: cloned
  });
}
